import React, { useState } from "react";
import "./sub.css";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import Formi from "./createsub";
import Modal from "react-bootstrap/Modal";
import SubInternet from "./subinternettable";

function Dealersubsss() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="internetsub">
      <div className="main-content">
        <div className="add-subscription">
          <button onClick={handleShow} className="add-button">
            Add Subscription
          </button>
          <Modal show={show} onHide={handleClose} className="modal-lg">
            <div className="modal-content">
              <Modal.Header closeButton>
                <Modal.Title>Add Subscription</Modal.Title>
              </Modal.Header>
              <Formi closeModal={handleClose} />
            </div>
          </Modal>
        </div>
        <SubInternet />
      </div>
    </div>
  );
}

export default Dealersubsss;
